module.exports = __webpack_public_path__ + "~@/assets/img/history.67b3aaac.png";